import { FieldType, DefaultFormTableSchema } from "./types";
export class LimitRedistributionSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            columnData: {
                applicationNumber: {
                    fieldType: FieldType.Text
                },
                limitGuid: {
                    fieldType: FieldType.Select
                }
            }
        });
    }
}
//# sourceMappingURL=LimitRedistributionSchema.js.map